module.exports = __webpack_public_path__ + "img/yz_gamebelieved_remind.1363944a.png";